import { NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './routing/app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/modules/shared.module';
import { FlightDetailsModule } from './flight-details/flight-details.module';
import { CalendarModule } from './calendar/calendar.module';
import { SequenceModule } from './sequence/sequence.module';
import { ToastrModule } from 'ngx-toastr';
import { AircraftModule } from '@flight-details/aircraft/aircraft.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { RedirectComponent } from './shared/components/redirect/redirect.component';
import { BreadcrumbComponent } from './shared/components/breadcrumb/breadcrumb.component';
import { RouteReuseStrategy } from '@angular/router';
import { CustomReuseStrategy } from '@routing/custom-reuse-strategy';
import { provideNativeDateAdapter } from '@angular/material/core';
import { HeaderInterceptor } from '@shared/interceptors/header-interceptor';
import { AngularMaterialModule } from '@shared/modules/angular-material.module';
import { OAuthModule } from 'angular-oauth2-oidc';
import { environment } from '@environments/environment';

@NgModule({
  declarations: [AppComponent, RedirectComponent, BreadcrumbComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    OAuthModule.forRoot({
      resourceServer: {
        allowedUrls: [
          environment.apiUrl,
          environment.crewBasicUrl,
          environment.crewDetailUrl,
          environment.flightDataServiceUrl,
        ],
        sendAccessToken: true,
      },
    }),
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      positionClass: 'toast-bottom-center',
      preventDuplicates: true,
      closeButton: true,
    }),
    SharedModule,
    AngularMaterialModule,
    CalendarModule,
    SequenceModule,
    FlightDetailsModule,
    AircraftModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: HeaderInterceptor, multi: true },
    { provide: RouteReuseStrategy, useClass: CustomReuseStrategy },
    provideHttpClient(withInterceptorsFromDi()),
    provideNativeDateAdapter(),
  ],
})
export class AppModule {}
